import { Component, OnInit } from '@angular/core';
import { QuizListWidget } from './components/quizlistwidget';
import { CommonModule } from '@angular/common';
import { UserService } from '../../layout/service/user.service';
import { Router } from '@angular/router';
import { PaginatorModule } from 'primeng/paginator';

@Component({
    selector: 'app-dashboard',
    imports: [
        QuizListWidget,
        CommonModule,
        PaginatorModule,
    ],
    template: `
    <div *ngIf="isAdmin; else tutorOrUserDashboard" class="mx-auto mb-8 p-8 bg-gradient-to-r from-[#5B8EEE] to-[#4DC8DF] rounded-3xl text-white relative overflow-hidden h-full min-h-[300px]">
        <div class="p-2 relative z-10 flex items-center h-full min-h-[200px]">
            <!-- Mobile background blur overlay -->
            <div class="rounded-2xl absolute inset-0 block lg:hidden" style="backdrop-filter: blur(12px); background: rgba(0, 0, 0, 0.25);"></div>
            <div class="flex-1 lg:pr-32 pr-0 relative">
                <h2 class="lg:text-5xl text-3xl font-bold text-white mb-4">Selamat Datang Kembali!</h2>
                <p class="lg:text-2xl text-lg font-medium mb-2">
                    Halo <span class="font-semibold">Admin</span>! Selamat Datang
                </p>
                <p class="lg:text-2xl text-lg opacity-90">
                    di Ruang Ujian Objektif berbasis Kompetensi.
                </p>
            </div>
        </div>
        <div class="absolute bottom-0 right-0">
            <img src="images/pana.png" alt="Medical Illustration" class="h-auto">
        </div>
    </div>
    <ng-template #tutorOrUserDashboard>
        <div *ngIf="isTutor; else userDashboard" class="mx-auto mb-8 p-8 bg-gradient-to-r from-[#5B8EEE] to-[#4DC8DF] rounded-3xl text-white relative overflow-hidden h-full min-h-[300px]">
            <div class="p-2 relative z-10 flex items-center h-full min-h-[200px]">
                <!-- Mobile background blur overlay -->
                <div class="rounded-2xl absolute inset-0 block lg:hidden" style="backdrop-filter: blur(12px); background: rgba(0, 0, 0, 0.25);"></div>
                <div class="flex-1 lg:pr-32 pr-0 relative">
                    <h2 class="lg:text-3xl text-2xl text-white mb-4" style="font-wight: 900">Selamat Datang Kembali!</h2>
                    <p class="lg:text-lg text-lg font-medium mb-2">
                        Halo <span class="font-semibold">Tutor</span>! Selamat Datang
                    </p>
                    <p class="lg:text-lg text-lg opacity-90">
                        di Ruang Ujian Objektif berbasis Kompetensi.
                    </p>
                </div>
            </div>
            <div class="absolute bottom-0 right-0">
                <img src="images/pana.png" alt="Medical Illustration" class="h-auto">
            </div>
        </div>
        <ng-template #userDashboard>
            <div class="mx-auto mb-8 p-8 bg-gradient-to-r from-[#5B8EEE] to-[#4DC8DF] rounded-3xl text-white relative overflow-hidden h-full min-h-[300px]">
                <div class="p-2 relative z-10 flex items-center h-full min-h-[200px]">
                    <!-- Mobile background blur overlay -->
                    <div class="rounded-2xl absolute inset-0 block lg:hidden" style="backdrop-filter: blur(12px); background: rgba(0, 0, 0, 0.25);"></div>
                    <div class="flex-1 lg:pr-32 pr-0 relative">
                        <h2 class="lg:text-3xl text-2xl text-white mb-4" style="font-weight:900;">Selamat Datang Kembali!</h2>
                        <p class="lg:text-lg text-lg font-medium mb-2">
                            Satu-satunya platform OSCE yang sesuai dengan PNUKNPDPD dan Universitasmu,
                        </p>
                        <p class="lg:text-lg text-lg opacity-90">
                            dilengkapi dengan station RME (Rekam Medis Elektronik)
                            <br> untuk mendukung kamu belajar OSCE.
                        </p>
                    </div>
                </div>
                <div class="absolute bottom-0 right-0">
                    <img src="images/pana.png" alt="Medical Illustration" class="h-auto">
                </div>
            </div>
            <div class="col-span-12 mb-4">
                <h3 class="text-2xl font-bold text-black flex items-center gap-3">
                    Daftar Kuis
                </h3>
            </div>
            <div class="grid grid-cols-12 gap-8 mb-4">
                <app-quiz-list-widget class="contents" />
            </div>
            <div class="col-span-12 mb-6">
                <h3 class="text-2xl font-bold text-black flex items-center gap-3">
                    Daftar Simulasi
                </h3>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                <div *ngFor="let sim of paginatedForms; let i = index" class="rounded-2xl flex flex-col h-full group relative overflow-hidden border border-white">
                    <div [ngClass]="getSimulationBgColor(i + currentPage * itemsPerPage)" class="p-4" >
                        <div class="mb-3">
                            <div class="flex items-center gap-2">
                                <i class="pi pi-calendar text-black text-sm"></i>
                                <span class="text-black/90 text-sm font-medium">
                                    {{
                                        sim.start_time
                                            ? (sim.start_time | date:'dd MMM yyyy')
                                            : '03 Jun 2025 00:00'
                                    }}
                                </span>
                            </div>
                        </div>
                        
                        <div class="mb-2">
                            <h3 class="text-black font-bold text-2xl mb-3">{{ sim.name }}</h3>
                            <div class="bg-black/20 text-white font-bold text-md px-3 py-2 rounded-lg w-fit">
                                <i class="pi pi-key text-white me-2"></i>
                                <span class="font-medium">{{ sim.code }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-5 bg-white">
                        <div class="text-black/80 text-sm mb-4 flex-1" [innerHTML]="sim.description || 'Tidak ada deskripsi untuk simulasi ini'"></div>
                        
                        <div class="flex flex-wrap gap-2 mb-4">
                            <span class="border border-black text-black text-xs px-3 py-1 rounded flex items-center gap-1">
                                <i class="pi pi-stop-circle"></i>
                                OSCE: {{ sim.osce?.length || 12 }}
                            </span>
                            <span class="border border-black text-black text-xs px-3 py-1 rounded flex items-center gap-1">
                                <i class="pi pi-clock"></i>
                                Durasi: {{
                                    sim.duration ?
                                        (+sim.duration >= 60 ? (+sim.duration / 60) : +sim.duration)
                                        : 15
                                }} Menit
                            </span>
                        </div>
                        
                        <button
                            class="w-full text-white font-bold py-3 px-4 bg-black rounded-xl border-2 border-black transition-all duration-200 flex items-center justify-center gap-2 hover:border-white/80"
                            (click)="goToSimulation(sim.code)">
                            <i class="pi pi-pause"></i>
                            MULAI SIMULASI
                        </button>
                    </div>
                    
                </div>
            </div>
            <div class="flex justify-center mt-8">
                <p-paginator 
                    [rows]="itemsPerPage" 
                    [totalRecords]="forms.length" 
                    [rowsPerPageOptions]="[6, 12, 18]" 
                    (onPageChange)="onPageChange($event)">
                </p-paginator>
            </div>
        </ng-template>
    </ng-template>
    `
})
export class Dashboard implements OnInit {
    isAdmin = false;
    isTutor = false;
    forms: any[] = [];
    currentPage: number = 0;
    itemsPerPage: number = 6;

    get paginatedForms(): any[] {
        const start = this.currentPage * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.forms.slice(start, end);
    }

    constructor(
        private userService: UserService,
        private router: Router
    ) {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);
                this.isAdmin = user.ID_ACCESS_ROLE === 'N2FWBVCZUE';
                this.isTutor = user.ID_ACCESS_ROLE === '4AEJ1KAJTY';
            } catch (e) {
                this.isAdmin = false;
                this.isTutor = false;
            }
        }
    }

    ngOnInit() {
        this.userService.getPackageSimulation().then((res) => {
            this.forms = res.data;
            this.forms = this.forms.map((form) => {
                form.osce = JSON.parse(form.osce_id);
                return form;
            });
        });
    }

    goToSimulation(code: string) {
        localStorage.setItem('simulation_code', code);
        this.router.navigate(['/app/osce/simulation']);
    }

    onPageChange(event: any) {
        this.currentPage = event.page;
    }

    getSimulationBgColor(i: number): string {
        const colors = [
            'bg-[#DBEDFA]',
            'bg-[#F3DFE3]', 
            'bg-[#E1F6E9]'
        ];
        return colors[i % colors.length];
    }

    getSimulationButtonColor(i: number): string {
        const colors = [
            'bg-[#52978C] hover:bg-[#52978C]/90',
            'bg-[#3B5A7C] hover:bg-[#3B5A7C]/90',
            'bg-[#A8103F] hover:bg-[#A8103F]/90'
        ];
        return colors[i % colors.length];
    }
}
